import { render, staticRenderFns } from "./LoadingModal.vue?vue&type=template&id=fe4ee4d2&"
import script from "./LoadingModal.vue?vue&type=script&lang=js&"
export * from "./LoadingModal.vue?vue&type=script&lang=js&"
import style0 from "./LoadingModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CProgress: require('@chakra-ui/vue').CProgress})
